import { useState, useEffect } from 'react';
import { LayoutContext, LAYOUT_TYPES } from './LayoutContext';

export function LayoutProvider({ children }) {
  const [layoutType, setLayoutType] = useState(() => {
    const saved = localStorage.getItem('controlvitals-layout');
    return saved || LAYOUT_TYPES.SIDEBAR;
  });

  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    const saved = localStorage.getItem('controlvitals-sidebar-collapsed');
    return saved === 'true';
  });

  useEffect(() => {
    localStorage.setItem('controlvitals-layout', layoutType);
  }, [layoutType]);

  useEffect(() => {
    localStorage.setItem('controlvitals-sidebar-collapsed', sidebarCollapsed);
  }, [sidebarCollapsed]);

  const toggleLayout = () => {
    setLayoutType(prev =>
      prev === LAYOUT_TYPES.SIDEBAR ? LAYOUT_TYPES.TOPNAV : LAYOUT_TYPES.SIDEBAR
    );
  };

  const toggleSidebar = () => {
    setSidebarCollapsed(prev => !prev);
  };

  return (
    <LayoutContext.Provider value={{
      layoutType,
      setLayoutType,
      toggleLayout,
      sidebarCollapsed,
      setSidebarCollapsed,
      toggleSidebar,
      isSidebarLayout: layoutType === LAYOUT_TYPES.SIDEBAR
    }}>
      {children}
    </LayoutContext.Provider>
  );
}
